(function(){
'use strict';

angular.module('classy').component('formSubLabel', {
  template: '\n      <div class="form__sub-label" \n      ng-transclude></div>\n    ',
  transclude: true
});
})();